import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NavMenuItem from "./NavMenuItem/NavMenuItem";

const NavMenu = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();
  const { pathname } = location;

  return (
    <ul className="flex flex-col md:flex-row gap-2 md:gap-4">
      <NavMenuItem destination="/#welcome" content="الرئيسية" />
      <NavMenuItem destination="/#whyMtor" content="لماذا موتور؟" />
      <NavMenuItem destination="/#mtorApps" content="الموردين" />
      <NavMenuItem destination="/#mtorApps" content="مراكز الخدمة" />
      <NavMenuItem
        destination={isAuthenticated ? "/categories" : "/login"}
        content={isAuthenticated ? "تصفح الأقسام" : "تسجيل الدخول"}
      />
      <NavMenuItem
        destination={
          pathname === "privacy-policy" ? "#policy" : "/privacy-policy"
        }
        content="سياسة الخصوصية"
      />
    </ul>
  );
};

export default NavMenu;
